import { styled } from '@mui/material/styles';

export const StatusContainer = styled('div')(() => ({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column'
}));

export const Baseline = styled('div')(({ theme, itemsCount, selectedIndex }) => ({
  marginTop: theme.spacing(5),
  height: theme.spacing(1),
  background: theme.color.background.default,
  width: '100%',
  display: 'flex',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    background: theme.color.success.main,
    width: `${(100 / (itemsCount - 1)) * selectedIndex}%`,
    bottom: '0px',
    height: theme.spacing(1),
    display: 'block',
    left: '0px'
  }
}));

export const Ball = styled('label')(({ theme, active, itemsCount, index }) => ({
  background: active ? theme.color.success.main : theme.color.background.default,
  height: theme.spacing(3),
  width: theme.spacing(3),
  borderRadius: theme.spacing(1.5),
  position: 'absolute',
  top: theme.spacing(-1),
  left: `${(100 / (itemsCount - 1)) * index}%`,
  transform: `translate(${theme.spacing(-1.5)}, 0)`
}));

export const LabelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  width: '100%',
  marginTop: theme.spacing(3)
}));

export const Label = styled('label')(({ theme, current, itemsCount, active }) => ({
  fontWeight: theme.fontWeight[current ? 'bold' : 'normal'],
  textAlign: 'center',
  width: `${100 / (itemsCount - 2)}%`,
  color: active || current ? theme.color.grey['800'] : theme.color.grey['400'],
  '&:first-child': {
    width: `${(100 / (itemsCount - 1)) * 0.5}%`,
    textAlign: 'left'
  },
  '&:last-child': {
    width: `${(100 / (itemsCount - 1)) * 0.5}%`,
    position: 'relative',
    left: theme.spacing(1.5),
    textAlign: 'right'
  }
}));

export const MobileStatus = styled('div')(({ theme }) => ({
  margin: theme.spacing(3),
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center',
  alignItems: 'center',
  '& div': {
    marginRight: theme.spacing(1)
  }
}));
